export default "__VITE_ASSET__BSWg5RsZ__"